import { FormGroup, Nav } from 'react-bootstrap';
import styled from 'styled-components';

export const Wrapper = styled.div`
    .ag-theme-alpine-dark {
        font-family: Roboto !important;
    }

    .ag-theme-bootstrap {
        font-family: Roboto !important;
    }
`;

export const GridWrapper = styled.div`
    height: 82vh;
    width: 100%;

    @media (max-height: 1080px) {
        height: 73vh;
    }


    .ag-header-cell {
        display: flex;
        justify-content: center;
        align-items: center;
        // padding-bottom: 5px;
        background-color: rgb(31, 125, 31);
        color: #fff;
    }

    .ag-header-cell > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
    }

    .ag-header-cell > .ag-react-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ag-header-cell > .ag-react-container > div {
        text-align: center;
    }

    .ag-cell {
        text-align: center;
        line-height: 30px;
    }

    .ilda-user-case-load {
        line-height: initial;
        display: flex;
        align-items: center;
    }

    .ilda-user-case-load > .ag-react-container {
        width: 100%;
    }

    .ilda-drop-down {
        display: flex;
        align-items: center;
    }

    .ilda-drop-down > .ag-react-container {
        width: 100%;
    }

    .ag-body-viewport {
        border-left: 1px solid rgb(204, 204, 204);
        border-right: 1px solid rgb(204, 204, 204);
        border-bottom: 1px solid rgb(204, 204, 204);
    }

    .ag-icon {
        color: white;
    }
`;

export const TableWrapper = styled.div`
    .table {
        border: 1px solid #eee;
        border-radius: 4px;
    }

    .table > thead > tr {
        background-color: #222628;
        color: #fff;
    }

    .table > thead > tr > th {
        text-align: center;
        border: 1px solid #fff;   
    }

    .table > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
    }

    // .table > tbody {
    //     // border: 1px solid pink;
    //     height: 400px;
    // }

    // .table-striped>tbody>tr:nth-of-type(even) {
    //     background-color: darkgrey !important;
    //     color: #fff;
    // }

    // .table-striped>tbody>tr:nth-of-type(odd) {
    //     background-color: #181d1f !important;
    //     color: #fff;
    // }
`;

interface INavWrapperProps {
    verticalAlign?: string,
    minTabWidth?: string
}

export const NavWrapper = styled(Nav) <INavWrapperProps>`
    & > li {
        height: 42px;
    }

    & > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: #ddd;
        color: #a1a1a1;
        // width: 160px;
        text-align: center;
        // line-height: 15px;
        padding: 5px 15px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: ${(p: INavWrapperProps) => p.verticalAlign ? p.verticalAlign : 'flex-end'};
        min-width: ${(p: INavWrapperProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        // font-size: 14px;
        // line-height: 15px;
        // padding: 5px 7.5px;
    }

    @media (max-width: 1823px) {
        & > li > a,
        & > li.active > a {
            // font-size: 12px;
            min-width: 120px;
        }
    }
`;

export const ViewWrapper = styled.div`
    padding-left: 2px;
    padding-right: 2px;

    .modal-container {
        position: relative;
    }

    .modal-container .modal, .modal-container .modal-backdrop {
        position: absolute;
    }
`;

export const FormGroupWrapper = styled(FormGroup)`
    margin-bottom: 5px;
    display: flex;
    align-items: center;

    & > .col-lg-3 {
        padding-left: 0px;
    }
`;

export const TableWrapperLeftAligned = styled.table`
    & > thead > tr {
        background-color: #ddd;
    }

    & > thead > tr > th:nth-child(1) {
        border-left: 1px solid #ddd;
    }

    & > thead > tr > th:last-child {
        border-right: 1px solid #ddd;
    }

    & > thead > tr > th {
        text-align: left;
        border: 1px solid white;
        padding-top: 3px;
        padding-bottom: 3px;
    }

    & > tbody > tr > td {
        text-align: left;
        padding-top: 3px;
        padding-bottom: 3px;
    }
`;